import { render, staticRenderFns } from "./CandidatesLabels.vue?vue&type=template&id=2faac7d5&scoped=true&lang=pug"
import script from "./CandidatesLabels.vue?vue&type=script&lang=js"
export * from "./CandidatesLabels.vue?vue&type=script&lang=js"
import style0 from "./CandidatesLabels.vue?vue&type=style&index=0&id=2faac7d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faac7d5",
  null
  
)

export default component.exports